import { Fragment } from 'react';
import Skeleton from 'react-loading-skeleton';

const printRows = (amount: number) => {
  const rows = [];

  for (let i = 1;i <= amount;i++) {
    rows.push(
      <Fragment key={ `listSk${ i }a` }>
        <div className='col-xs-1'><Skeleton /></div>
        <div className='col-md-11'><Skeleton /></div>
      </Fragment>
    );
  }

  return rows;
};

export interface DataTableLoaderProps {
  /** Кол-во строк-скелетонов. @default 8 */
  rows?: number;
}

const DataTableLoader = ({ rows = 8 }: DataTableLoaderProps) => {
  const styleHeader = { fontSize: 30, lineHeight: 2 };
  const styleNormal = { fontSize: 25, lineHeight: 2 };

  return (
    <>
      <div className='row' style={ styleHeader }>
        <div className='col-xs-1'><Skeleton /></div>
        <div className='col-xs-3'><Skeleton /></div>
        <div className='col-xs-2'><Skeleton /></div>
        <div className='col-xs-1'><Skeleton /></div>
        <div className='col-xs-2'><Skeleton /></div>
        <div className='col-xs-2'><Skeleton /></div>
        <div className='col-xs-1'><Skeleton /></div>
      </div>
      <div className='row' style={ styleNormal }>
        { printRows(rows) }
      </div>
      <div className='row' style={ styleNormal }>
        <div className='col-md-3'><Skeleton /></div>
        <div className='col-md-2 col-md-offset-7'><Skeleton /></div>
      </div>
    </>
  );
};

export default DataTableLoader;
